module.exports = __webpack_public_path__ + "static/media/8604-r.8f57a347.png";